export default "__VITE_ASSET__BYoyjp4s__"